import React from 'react';
import { Link } from 'react-router-dom';

const ServicesAlt4 = () => {
  const services = [
    {
      id: 'listing-optimization',
      title: 'Listing Optimization',
      description: 'Visibility - Sales – Optimize Your Amazon Listings and Convert Visibility into Dollars. With expert Amazon Product Listing Optimization, we enhance your listings to improve search rankings and attract more clicks. Our SEO-friendly strategies turn views into higher sales and a stronger brand presence, increasing your Amazon sales.',
      icon: '📈',
      bgClass: 'from-orange-500/20 via-orange-600/10 to-transparent',
      number: '01',
    },
    {
      id: 'ppc-management',
      title: 'Amazon PPC Campaign Management',
      description: 'Amazon PPC - Turn Clicks into Profits. With expert Amazon Marketing Services, we turn data into results. Our targeted strategies drive conversions and increase profitability, making every click will help you reach your goal of becoming profitable on Amazon.',
      icon: '🎯',
      bgClass: 'from-blue-500/20 via-blue-600/10 to-transparent',
      number: '02',
    },
    {
      id: 'keyword-seo',
      title: 'Amazon Keywords SEO',
      description: 'Rank Higher - Sell More. With expert Amazon Keywords SEO, we help your products rank higher and reach the right customers. Our strategy increases visibility and drives more sales, turning search results into revenue.',
      icon: '🔍',
      bgClass: 'from-purple-500/20 via-purple-600/10 to-transparent',
      number: '03',
    },
    {
      id: 'analytics',
      title: 'Amazon Listing Graphics',
      description: 'Great Images - More Sales. Transform your listings with eye-catching Amazon Product Images, A+ Content Design and Brand Store that highlight your product\'s unique features. Our designs grab attention, boost conversions, and make your brand unforgettable.',
      icon: '🎨',
      bgClass: 'from-green-500/20 via-green-600/10 to-transparent',
      number: '04',
    },
    {
      id: 'product-research',
      title: 'Amazon Product Research',
      description: 'Research – Profits. With expert product research, we help you identify high-demand items and profitable niches, ensuring your Amazon business is always ahead of the competition.',
      icon: '📊',
      bgClass: 'from-pink-500/20 via-pink-600/10 to-transparent',
      number: '05',
    },
    {
      id: 'brand-registration',
      title: 'Amazon Brand Registration',
      description: 'Branding – Trust. We guide you through the Amazon Brand Registry process, ensuring your brand is protected, stands out, and gains access to exclusive tools that drive growth and increase customer trust.',
      icon: '✅',
      bgClass: 'from-yellow-500/20 via-yellow-600/10 to-transparent',
      number: '06',
    },
    {
      id: 'catalogue-management',
      title: 'Amazon Catalogue Management',
      description: 'Planning – Efficiency. Our Catalog Management service ensures smooth operations by handling product availability, stock levels, price adjustments, and more, so your listings are always accurate and ready to convert.',
      icon: '📚',
      bgClass: 'from-orange-500/20 via-orange-600/10 to-transparent',
      number: '07',
    },
    {
      id: 'account-management',
      title: 'Amazon Account Management',
      description: 'Strategy – Success. Let us manage your Amazon account from start to finish. We handle listing optimization, SEO, PPC, seasonality planning, and performance tracking, so you can focus on growing your business.',
      icon: '💼',
      bgClass: 'from-blue-500/20 via-blue-600/10 to-transparent',
      number: '08',
    },
    {
      id: 'troubleshooting',
      title: 'Amazon Trouble Shootings',
      description: 'Error – Solution. Facing issues on Amazon? No worries, our experts are here to quickly resolve any challenges, ensuring your account runs smoothly and your business stays on track.',
      icon: '🛠️',
      bgClass: 'from-purple-500/20 via-purple-600/10 to-transparent',
      number: '09',
    },
  ];

  return (
    <section className="bg-black text-white py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <div className=" mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <div className="inline-block bg-primary/20 text-primary px-6 py-2 rounded-full text-sm font-medium mb-6">
              OUR SERVICES
            </div>
            <h2 className="text-5xl md:text-6xl font-bold">Amazon Account Management Services</h2>
          </div>
          <div>
            <p className="text-lg text-white/80">
            Scale and automate your entire Amazon Seller account with complete control everything from Product Listings to Inventory Management, Main Images to Store Designing, Brand Registry to Brand Growth is just one step away.
            </p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <Link
              key={service.title}
              to={`/services/${service.id}`}
              className="group relative rounded-2xl"
            >
              {/* Card Content */}
              <div className="relative p-8 bg-black/40 backdrop-blur-sm border border-primary/20 rounded-2xl h-full hover:border-primary/40 transition-colors duration-300 shadow-[0_0_15px_rgba(241,90,41,0.1)] hover:shadow-[0_0_20px_rgba(241,90,41,0.2)]">
                <div className={`absolute inset-0 bg-gradient-to-br ${service.bgClass} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />
                
                <div className="relative z-10 flex flex-col h-full">
                  {/* Service Number */}
                  <div className="text-6xl font-bold text-white/10 absolute top-4 right-4">
                    {service.number}
                  </div>

                  {/* Icon */}
                  <div className="text-3xl mb-4">{service.icon}</div>

                  {/* Title */}
                  <h3 className="text-xl font-bold mb-4 group-hover:text-primary transition-colors duration-300">
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p className="text-white/70 mb-12">
                    {service.description}
                  </p>

                  {/* Hover Indicator */}
                  <div className="absolute bottom-8 right-8 opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300">
                    <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center cursor-pointer hover:bg-primary/30 transition-colors duration-300">
                      <svg className="w-4 h-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesAlt4;
